import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AddPopupComponent } from '../Popups/add-popup/add-popup.component';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-team-listing',
    templateUrl: './team-listing.component.html',
    styleUrls: ['./team-listing.component.css']
})
export class TeamListingComponent implements OnInit {
    teams = [
        { name: 'Finance Team', employeeCount: '200', reporting: 'HR Team' },
        { name: 'Sonepar Asia - Pacific', employeeCount: '150', reporting: 'HR Team' },
        { name: 'Sales Team', employeeCount: '112', reporting: 'HR Team' },
        { name: 'Admin Team', employeeCount: '15', reporting: 'CEO' },
    ];

    constructor(public dialog: MatDialog,
        public _location: Location,
        public mobileNav: MobileNavService) { }

    openDialog(): void {
        let dialogRef = this.dialog.open(AddPopupComponent, {
            width: '300px',
            data: { title: 'Add New Team' }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
        });
    }

    onClickMe() {
        this.mobileNav.showSideNav();
    }

    ngOnInit() {
    }
    backBtnClick() {
        this._location.back();
    }
}
